import { IDistributorMigration } from "../pages/MigrationQueue"
import { IMigrationHistory, IMigrationStats } from "../pages/MigrationStatus"
import endpoints from "../utils/endpoints"
import { removeEmpty } from "../utils/objectUtils"
import { Api } from "./api"
import { notificationError, notificationSucces } from "./notification"

export async function getMigrationStatus(parameters: any) {
  let res: {
    migrationStats: IMigrationStats,
    migrationHistory: IMigrationHistory[]
  } = {
    migrationStats: {
      queued: 0,
      running: 0,
      cancelled: 0,
      failed: 0,
      finished: 0
    },
    migrationHistory: []
  }

  const params = removeEmpty(parameters)

  await Api.get(endpoints.getMigrationStatus, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get migration status')
    }
  }).catch((err: string) => {
    notificationError('Could not get migration status')
  })

  return res
}

export async function getRunningMigration() {
  let res = {enabled: false}

  await Api.get(endpoints.getRunningMigration).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get migration status')
    }
  }).catch((err: string) => {
    notificationError('Could not get migration status')
  })

  return res
}

export async function starOrtStopMigration(type: 'start' | 'stop') {

  const message = type === 'start' ? 'started' : 'stopped'

  await Api.get(type === 'start' ? endpoints.startMigration : endpoints.stopMigration).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
       notificationSucces(`Migration ${message}`)
      }
    } else {
      notificationError(`Could not ${type} migration`)
    }
  }).catch((err: string) => {
    notificationError(`Could not ${type} migration`)
  })

}

export async function deleteMigrationById(params: any) {
  await Api.get(endpoints.deleteMigration, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
       notificationSucces(`Migration deleted`)
      }
    } else {
      notificationError(`Could not delete migration`)
    }
  }).catch((err: string) => {
    notificationError(`Could not delete migration`)
  })
}

export async function getMigrationDetailsById(params: any) {
  let res = {queuedId:"", detailMsg:""}
  await Api.get(endpoints.getMigrationDetails, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
       res = response.data
      }
    } else {
      notificationError(`Could not get migration details`)
    }
  }).catch((err: string) => {
    notificationError(`Could not get migration details`)
  })
  return res
}